import Cookies from 'universal-cookie'
import { BACKEND_URL } from '../config.js'

// export const url = 'airsig.kgpl.com';
// export const media_url = 'airsig.kgpl.com/media/';
// export const url = 'http://airsig.kgpl.com';

// export const url = 'http://airsig.kgpl.com';
// require('dotenv').config();
// export const url = `http://${process.env.BACKEND_URI}:8000`;
// export const url = `http://${window.location.host}`
// export const media_url = 'http://127.0.0.1:8000/media/';
// export const url = 'http://airsig.kgpl.com'

// export const url = `http://${window.location.hostname}:8601`
// export const url = `https://airsig.uil.co.nz`
export const url = `${BACKEND_URL}`
export const media_url = 'http://airsig.kgpl.com/'

export const logout = () => {
    const cookies = new Cookies()
    cookies.remove('loggedIn', { path: '/' })
    window.location = '/login'
}

export const getUserInfo = () => {
    const cookies = new Cookies()
    const user_id = cookies.get('user_id')
    const token = cookies.get('token')
    const loggedIn = cookies.get('loggedIn')
    return {
        user_id,
        token,
        loggedIn,
    }
}



// WEBPACK FOOTER //
// src/components/helper.js